// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202602271103/js/" + chunkId + "." + {"44":"aef2c98f","225":"5d7b4c79","481":"2ff5d689","486":"109b0d5e","770":"f2bf8d5c"}[chunkId] + ".0.08200578951620985.chunk.js";
};